import Swiper from "swiper";
import { Navigation, A11y, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/a11y";

document.querySelectorAll(".swiperteam").forEach(function (thisSlider) {
  const id = thisSlider.id; // make sure your slider element has a unique ID
  const slider = document.getElementById(id);
  const container = slider.parentElement;

  const options = {
    modules: [Navigation, A11y, Pagination],
    a11y: {
      enabled: true,
    },
    breakpoints: {
      0: {
        slidesPerView: 1.1,
        spaceBetween: 19,
      },
      576: {
        slidesPerView: 2.1,
        spaceBetween: 19,
      },
      992: {
        slidesPerView: 3.1,
        spaceBetween: 19,
      },
      1200: {
        slidesPerView: 4.1,
        spaceBetween: 19,
      },
    },
  };

  if (window.innerWidth >= 768) {
    const swiper = new Swiper(slider, {
      ...options,
      navigation: {
        nextEl: container.querySelectorAll(".team-next")[0],
        prevEl: container.querySelectorAll(".team-prev")[0],
      },
    });
  } else {
    const swiper = new Swiper(slider, {
      ...options,
      navigation: {
        nextEl: container.querySelectorAll(".team-next")[1],
        prevEl: container.querySelectorAll(".team-prev")[1],
      },
    });
  }
});
